import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHeartFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26 10.398C26 6.393 23.603 4 19.598 4 17.255 4 15.058 5.887 14 6.953 12.942 5.887 10.745 4 8.402 4 4.397 4 2 6.393 2 10.398c0 3.282 2.946 6.03 3.054 6.125l8.357 8.23c.16.165.375.247.589.247a.822.822 0 0 0 .59-.246l8.343-8.203c.12-.123 3.067-2.871 3.067-6.153Z" />
  </svg>
);
export default SvgHeartFilled;
